import React, { createContext, useContext, useState } from "react";
import useAxiosPrivate, { axiosHrPrivate } from "../api/useAxios";
import { useAuth } from "./auth";


function LookupGroupProvider(props) {
    const axiosPrivate = useAxiosPrivate(axiosHrPrivate)
    const { activeLanguage } = useAuth()
    const [lookupGroupList, setLookupGroupList] = useState([])

    const getLookupDataFromApi = async (lookupGroup) => {
        try {
            var response = await axiosPrivate.get(`/api/LookupData/LookupGroup/${lookupGroup.id}`)
            if (response) {
                if (response.data?.data) {
                    return response?.data?.data.sort((a, b) => a.order - b.order).map(item => ({ id: item.id, text: item.text }))
                }
            }
            return null
        } catch (error) {
            console.log("getLookupDataFromApi error : ", error)
        }
    }

    const checkValue = (lookupGroup) => {

        if (!lookupGroup?.expireDate)
            return false
        if (lookupGroup.language !== activeLanguage)
            return false

        var now = new Date(Date.now())
        var expireDate = new Date(lookupGroup.expireDate)
        return expireDate > now

    }

    const getLookupData = async (lookupGroup, refresh) => {
        
        //bu şekilde saklanacak her bir alan
        // result = { 
        //     name:"" ,
        //     expireDate:"",
        //     language:"tr-TR",
        //     data:[], 

        //     }

        var result = ""

        if (!refresh) {
            result = lookupGroupList.find((item) => item.name === lookupGroup.name)

            if (result && checkValue(result))
                return result.data

            result = JSON.parse(localStorage.getItem("LookupGroup-" + lookupGroup.name))

            if (result && checkValue(result)) {
                setLookupGroupList(prevState => [...prevState, result]);
                return result.data
            }
        }

        var data = await getLookupDataFromApi(lookupGroup)

        if (data) {
            var expireDate = new Date(Date.now() + (1000 * 60 * 60 * 24));//1 günlük, 
            //ileride dataya yazacağımız bir tarihe göre listelerin güncellenmesini sağlayabiliriz.
            result = {
                name: lookupGroup.name,
                expireDate: expireDate,
                language: activeLanguage,
                data: data //.sort((a, b) => a.order - b.order).map(item => ({ id: item.id, text: item.text })), apide yaptım
            }
            localStorage.setItem("LookupGroup-" + lookupGroup.name, JSON.stringify(result))
            setLookupGroupList(prevState => [...prevState, result]);
            return result.data
        }
    }

    return (
        <LookupGroupContext.Provider value={{
            getLookupData
        }} {...props} />
    );

}

const LookupGroupContext = createContext({})
const useLookupGroup = () => useContext(LookupGroupContext)

export { LookupGroupProvider, useLookupGroup }